/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {Toast} from 'react-weui'
import {WKSearchBar} from '../../components/wk'
import {getJsonFromUrl, printObject, isLZWKAPP} from '../../utils'
import {browserHistory} from 'react-router'

class SearchSearchBar extends React.Component {

    constructor(){
        super();
        this.state = {
            showLoading: false
        }
    }

    componentDidMount() {
        // let target = document.querySelector('.search-page-searchbar');
        // target.querySelector('form').setAttribute('action','');
        // target.querySelector('input').focus();
    }

    handleChange(text) {
        this.props.dispatch({
            type: 'SEARCH_SEARCH_TEXT',
            payload: text
        });
    }

    hendleSearch() {
        const {search, account} = this.props;

        if (search.search_text !== ''){
            this.props.dispatch({
                type: 'SEARCH_CLEAR'
            });

            let target = document.querySelector('.search-page-searchbar');
            target.querySelector('input').blur();

            this.setState({
                showLoading: true
            });

            /*this.props.dispatch({
                type: "STATS_LOG",
                payload: {
                    action: 'seawords',
                    ts: new Date().getTime(),
                    account_id: account && account.id,
                    keyword: search.search_text
                }
            });*/

            //GET LIVEROOM INDEX
            axios.get('/api/board/search',{
                params: {
                    q: search.search_text,
                    type: 'liveroom',
                }
            }).then(res => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'SEARCH_LIVEROOM_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'SEARCH_LIVEROOM_LIST',
                        payload: res.data.data.records
                    });
                    if (this.state.showLoading){
                        this.setState({
                            showLoading: false
                        });
                    }
                }
            });

            //GET CHANNEL INDEX
            axios.get('/api/board/search',{
                params: {
                    q: search.search_text,
                    type: 'channel',
                }
            }).then(res => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'SEARCH_CHANNEL_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'SEARCH_CHANNEL_LIST',
                        payload: res.data.data.records
                    });
                    if (this.state.showLoading){
                        this.setState({
                            showLoading: false
                        });
                    }
                }
            });

            //GET LECTURE INDEX
            axios.get('/api/board/search',{
                params: {
                    q: search.search_text,
                    type: 'lecture',
                }
            }).then(res => {
                if (res.data.code === 0){
                    this.props.dispatch({
                        type: 'SEARCH_LECTURE_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'SEARCH_LECTURE_LIST',
                        payload: res.data.data.records
                    });
                    if (this.state.showLoading){
                        this.setState({
                            showLoading: false
                        });
                    }
                }
            });

            if(!isLZWKAPP()){
                if ("pushState" in window.history) {
                    let query = window.location.search;
                    let q = new RegExp('q');
                    let data = getJsonFromUrl();
                    function printObject(obj) {
                        let result = '';
                        for (let i in obj) {
                            result = result + i + '=' + obj[i] + '&';
                        }
                        let length = result.length;
                        result = result.substr(0,length - 1);
                        return result;
                    }
                    if (query === ''){
                        window.history.replaceState({
                                title: document.title,
                                url: location.href + `?q=${encodeURIComponent(search.search_text)}`
                            },
                            document.title, location.href + `?q=${encodeURIComponent(search.search_text)}`
                        );
                    }else {
                        if (q.test(query)){
                            data.q = search.search_text;
                            window.history.replaceState({
                                    title: document.title,
                                    url: location.origin + location.pathname + "?" + printObject(data)
                                },
                                document.title, location.origin + location.pathname +  "?" + printObject(data)
                            );
                        }else {
                            window.history.replaceState({
                                    title: document.title,
                                    url: location.href + `&q=${encodeURIComponent(search.search_text)}`
                                },
                                document.title, location.href + `&q=${encodeURIComponent(search.search_text)}`
                            );
                        }
                    }
                }
            }

        }else {
            this.context.page.showTips('请输入搜索关键字', 'default');
        }
    }

    handleClear() {
        this.props.dispatch({
            type: 'SEARCH_CLEAR'
        });
        browserHistory.replace('/search')
    }

    handleBackIndex() {
        if (isLZWKAPP()){
            this.props.dispatch({
                type: 'SEARCH_CLEAR'
            });
        }else {
            location.assign('/')
        }
    }

    render() {
        return(
            <div className="search-page-searchbar">
                <WKSearchBar
                    onChange={this.handleChange.bind(this)}
                    onSubmit={this.hendleSearch.bind(this)}
                    defaultValue={this.props.search.search_text}
                    autoFocus={true}
                    placeholder="请输入内容"
                    lang={{
                        cancel: '取消'
                    }}/>
                <Toast icon="loading" show={this.state.showLoading} />
            </div>
        )
    }
}

SearchSearchBar.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    search: state.search,
    account: state.account
}))(SearchSearchBar)


// WEBPACK FOOTER //
// ./src/components/search/SearchSearchBar.js